<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-secondary itemTitle="청약신청" bg="/images/form/application/visual.jpg">
                <template #title>청약신청</template>
            </sub-head-secondary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <v-row align="center">
                <v-col cols="12" lg="6" order-lg="2">
                    <v-card tile class="pa-24px px-md-40px py-md-84px">
                        <tit-wrap class="tit-wrap--sm">
                            <tit-wrap class="tit-wrap--xs">
                                <tit class="font-secondary primary--text">The Podium 830</tit>
                            </tit-wrap>
                            <tit>더포디엄830 청약신청 접수/조회</tit>
                        </tit-wrap>

                        <tit-wrap class="tit-wrap--sm">
                            <div v-if="isBeforeOpen" class="tit">청약신청 시작전입니다.</div>
                            <v-row v-else-if="!isDead" class="row--xs">
                                <v-col cols="auto">
                                    <v-btn tile x-large color="black" class="white--text v-btn--width-fixed" @click="open">
                                        <span class="font-size-14 font-size-lg-16">청약신청/조회</span>
                                    </v-btn>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn tile x-large color="primary" class="v-btn--width-fixed" to="/subscription/recruitment">
                                        <span class="font-size-14 font-size-lg-16">모집공고 다운로드</span>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <div v-else class="tit">청약신청 기간이 아닙니다.</div>
                        </tit-wrap>
                        <sheet-primary>
                            <v-row>
                                <v-col cols="12">
                                    <v-row class="row--xxs">
                                        <v-col cols="12">
                                            <txt class="font-weight-bold txt--dark">주택위치</txt>
                                        </v-col>
                                        <v-col>
                                            <txt class="font-weight-bold">
                                                서울특별시 광진구 자양동 8-8외 3필지 <br />
                                                (2호선, 7호선 건대입구역 6번출구)
                                            </txt>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12">
                                    <v-row class="row--xxs">
                                        <v-col cols="12">
                                            <txt class="font-weight-bold txt--dark">공급호수</txt>
                                        </v-col>
                                        <v-col>
                                            <txt class="font-weight-bold">
                                                총 480 세대 중 민간임대 313세대 <br />
                                                (특별공급 63세대, 일반공급 250세대)
                                            </txt>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </sheet-primary>
                    </v-card>
                </v-col>
                <v-col cols="12" lg="6">
                    <v-img max-width="588" src="/images/sub/application/application.png" class="mx-auto" />
                </v-col>
            </v-row>
        </page-section-primary>
        <application-dialog ref="applicationDialog" />
    </app-primary>
</template>

<script>
import { mapGetters } from "vuex";
import { APPLICATION_TYPE } from "@/assets/variables";
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadSecondary from "@/sets/parents/pages/sub-head-secondary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import FormInput from "@/components/client/form/form-input.vue";

import TitWrap from "@/components/publish/styles/typography/tit-wrap.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

import SheetPrimary from "@/components/publish/parents/sheets/sheet-primary.vue";
import api from "@/api";

import ApplicationDialog from "@/components/client/application/application-dialog.vue";

export default {
    components: {
        AppPrimary,
        SubHeadSecondary,
        PageSectionPrimary,
        FormInput,

        TitWrap,
        Tit,
        Txt,

        SheetPrimary,

        ApplicationDialog,
    },
    data() {
        return {
            APPLICATION_TYPE,
            surveyURL: "/",
        };
    },
    computed: {
        ...mapGetters("schedule", ["isStop", "isDead", "isBeforeOpen", "message_beforeOpen", "message_dead", "message_stop"]),

        // tempBlock
        today() {
            return this.$dayjs();
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        open() {
            // tempBlock
            try {
                if (this.isStop) throw new Error(this.message_stop);
                if (this.isDead) throw new Error(this.message_dead);
                if (this.isBeforeOpen) throw new Error(this.message_beforeOpen);

                this.$refs.applicationDialog.show = true;
            } catch (error) {
                alert(error.message);
            }
        },
        async search() {
            try {
                const { surveyURL } = await api.v1.setting.getSuveryURL();
                this.surveyURL = surveyURL;
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>
